export default () => ({
  id: null,
  opportunity_id: null,
  online_opportunity_id: null,
  nfl_event_type: null,
  category_id: null,
  department_id: null,
  others_can_apply: false,
  show_all_talents: false,
  name: null,
  organisation_name: null,
  appearance_type: null,
  dress_code: null,
  video_url: null,
  establishment: null,
  additional_location_detail: null,
  street_address: null,
  suburb: null,
  state: null,
  country: null,
  postcode: null,
  area: null,
  latitude: null,
  longitude: null,
  complete_by_date: null,
  date: null,
  date2: null,
  date3: null,
  date_options: null,
  arrival_time: null,
  travel_time: null,
  athlete_start_time: null,
  athlete_leave_time: null,
  event_duration: null,
  duration: null,
  date_flexible_or_unconfirmed: false,
  time_flexible_or_unconfirmed: false,
  required_stars: 1,
  budget_per_star: null,
  budget_code: null,
  budget_not_confirmed: false,
  description: null,
  requirements: null,
  expenses_covered: false,
  promoted_publicly: false,
  coupon: null,
  market_segment: null,
  market_segment_subcategory: null,
  admin: null,
  currency: null,
  segment: null,
  agency_stage: null,
  opportunities: [],
  location_unconfirmed: false,
  commercial_purposes: false,
  video_caption: null,
  video_message_first_name: null,
  video_message_last_name: null,
  video_message_places: [],
  video_rights_length: null,
  ambassador_length: null,
  target_market: null,
  ambassadorship_details: null,
  marketing_channels: null,
  shoot_required: false,
  post_caption: null,
  social_post_location: null,
  number_of_social_media_posts: null,
  paid_advertising: false,
  rights_length: null,
  other: null,
  other_agency_stage: null,
  other_video_usage: null,
  commencement_date: null,
  region_id: null,
  commission_rate: null,
  commission_type: null,
  commission_dollar: null,
  aca_event_location: null,
  aca_event_distance: null,
  aca_event_gender: null,
  aca_number_participants: 0,
  aca_participant_ability: null,
  custom_fields: null,
  files: [],
  campaign_id: null,
  cost_centre: null,
  gl_code: null,
  is_offer: null
})
